import {useQuery} from 'react-query'
import {CartypeEditModalForm} from './CartypeEditModalForm'
// import {isNotEmpty, QUERIES} from '../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getCartypeById} from '../core/_requests'
import { QUERIES, isNotEmpty } from '../../../../../_metronic/helpers'

const CartypeEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const dataresponse = {name:"demo"}
  const {
    isLoading,
    data: cartype,
    error,
  } = useQuery(
    `${QUERIES.CARTYPES_LIST}-cartype-${itemIdForUpdate}`,
    () => {
      return getCartypeById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
       // setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return <CartypeEditModalForm isCartypeLoading={false} cartype={{id: undefined}} />
  }

  if (itemIdForUpdate) {
    return <CartypeEditModalForm isCartypeLoading={false} cartype={dataresponse} />
  }

  return null
}

export {CartypeEditModalFormWrapper}
